<dialog id="add_organization_modal" class="modal">
  <div class="modal-box w-full max-w-lg p-6 relative rounded-2xl">
    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" (click)="closeAddOrganizationModal()">
      ✕
    </button>
    <div class="flex gap-2 mb-4">
      <div class="w-9 h-9 flex flex-col items-center justify-center rounded border border-base-300">
        <fa-icon [icon]="'plus'" class="text-primary text-xl"></fa-icon>
      </div>
      <div>
        <h2 class="text-lg font-semibold mb-1 text-primary">Add Organization</h2>
      </div>
    </div>
    <form [formGroup]="addOrganizationForm" (ngSubmit)="onSubmit()">
      <!-- Organization Name Field -->
      <label class="block text-base font-medium text-primary-focus mb-1 pt-4">
        <span><span class="text-error text-lg font-bold">*</span>Organization Name:</span>
        <input
          type="text"
          id="display_name"
          formControlName="display_name"
          placeholder="Enter name"
          class="input input-bordered w-full h-10 rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
        />
        <span
          *ngIf="addOrganizationForm.get('display_name')?.invalid && addOrganizationForm.get('display_name')?.touched"
          class="block text-sm text-error mt-1"
        >
          Organization name is required
        </span>
      </label>

      <!-- Reportable-pathogen auto-approval toggle -->
      <label class="block text-base font-medium border-t border-base-300 pt-4 text-primary-focus mt-4 mb-4">
        <span>Reportable-pathogen auto-approval:</span>
        <div class="flex items-center gap-3 mt-1">
          <span class="text-sm text-primary">No</span>
          <label class="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              id="default_approve"
              formControlName="default_approve_analytical_dataset_requests"
              class="sr-only peer"
            />
            <div class="w-9 h-5 bg-base-300 rounded-full transition-colors duration-300 peer-checked:bg-info"></div>
            <span
              class="absolute left-[2px] top-[2px] bg-base-100 rounded-full h-4 w-4 shadow transition-all duration-300 peer-checked:translate-x-4"
            ></span>
          </label>
          <span class="text-sm text-primary">Yes</span>
        </div>
      </label>

      <!-- Request guidelines toggle -->
      <label class="block text-base font-medium border-t border-base-300 pt-4 text-primary-focus mt-4">
        <span>Request guidelines:</span>
        <div class="flex items-center gap-3 mt-1">
          <span class="text-sm text-primary">Off</span>
          <label class="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              id="request_guidelines_enabled"
              formControlName="request_guidelines_enabled"
              class="sr-only peer"
            />
            <div class="w-9 h-5 bg-base-300 rounded-full transition-colors duration-300 peer-checked:bg-info"></div>
            <span
              class="absolute left-[2px] top-[2px] bg-base-100 rounded-full h-4 w-4 shadow transition-all duration-300 peer-checked:translate-x-4"
            ></span>
          </label>
          <span class="text-sm text-primary">On</span>
        </div>
      </label>

      @if (addOrganizationForm.get('request_guidelines_enabled')?.value) {
        <!-- Data Catalog banner text -->
        <label class="block text-base font-medium text-primary-focus mt-4">
          <span>Data Catalog banner text:</span>
          <textarea
            formControlName="request_guidelines_catalog_text"
            rows="2"
            placeholder="Short notice shown on the Data Catalog page"
            class="textarea textarea-bordered w-full rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
          ></textarea>
        </label>

        <!-- Request modal disclaimer text -->
        <label class="block text-base font-medium text-primary-focus mt-4">
          <span>Request modal disclaimer text:</span>
          <textarea
            formControlName="request_guidelines_modal_text"
            rows="3"
            placeholder="Longer disclaimer shown in the dataset request modal"
            class="textarea textarea-bordered w-full rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
          ></textarea>
        </label>

        <!-- Learn more link -->
        <label class="block text-base font-medium text-primary-focus mt-4 mb-4">
          <span>"Learn more" link (optional):</span>
          <input
            type="url"
            formControlName="request_guidelines_url"
            placeholder="https://..."
            class="input input-bordered w-full h-10 rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
          />
        </label>
      }

      <!-- Footer buttons -->
      <div class="flex justify-between gap-3 pt-4 border-t border-base-300 mt-4">
        <button
          type="button"
          class="w-[104px] h-8 rounded border border-base-300 bg-base-100 text-sm font-medium text-dark hover:bg-base-200 transition-colors"
          (click)="closeAddOrganizationModal()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="h-8 px-6 min-w-[160px] border border-base-300 rounded text-sm text-dark font-medium hover:bg-info hover:text-white transition-colors"
          [disabled]="addOrganizationForm.invalid"
        >
          Add Organization
        </button>
      </div>
    </form>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button>close</button>
  </form>
</dialog>
